<template>
  <div class="teacher-list-page">
    <TeacherCard
      v-for="teacher in teachers"
      :key="teacher.id"
      :teacher="teacher"
      @click="goDetail"
    />
    <div v-if="!teachers.length" class="empty">
      <van-empty description="暂无老师" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import TeacherCard from '@/components/TeacherCard.vue';

const router = useRouter();

// mock数据
const teachers = ref([
  {
    id: 1,
    name: '胡林',
    subject: '数学',
    classCount: 2,
    avatar: '', // 可替换为真实图片url
  },
  {
    id: 2,
    name: 'xx',
    subject: '数学',
    classCount: 1,
    avatar: '',
  },
]);

function goDetail(teacher) {
  router.push({
    path: '/teacherDetail',
    query: { id: teacher.id },
  });
}
</script>

<style lang="scss" scoped>
.teacher-list-page {
  background: #f7f8fa;
  min-height: 100vh;
  padding: 0 0 16px 0;
}
.empty {
  margin-top: 100px;
}
</style> 